"use client";

import { IUserSubsRefundAmount } from "@src/api/user/user";
import MgButton from "@src/components/button/MgButton";
import { ISubsribeInfo } from "@src/hooks/subscribe/useSubscribe";
import React from "react";
import { css, styled } from "styled-components";

interface Props {
    userSubsInfo?: ISubsribeInfo;
    onChangeStep: (val: number) => void;
    onCloseView: () => void;
    subsRefundAmount?: IUserSubsRefundAmount;

    setIsOpenImmediateTerminateNoneDeposit?: () => void;
    onSubmitUserSubsRemoveReserve?: () => void;
    setIsOpenReservationModal?: () => void;
}

const TerminateFirstStep: React.FC<Props> = ({
    userSubsInfo,
    onChangeStep,
    onCloseView,
    subsRefundAmount,
    setIsOpenImmediateTerminateNoneDeposit,
    onSubmitUserSubsRemoveReserve,
    setIsOpenReservationModal,
}) => {
    return (
        <ContentBoxSecondStyle>
            <div className="ExplanationBox">
                <p className="ExplanationTitle">
                    <div>지금 해지하시면</div>
                    <div>{subsRefundAmount?.benefitPrice.toLocaleString()}원 할인 혜택이 사라져요!</div>
                </p>
                <p className="ExplanationSubTitle">그래도 해지하시겠습니까?</p>
                <div className="ExplanationText">
                    해지에 따른 공제액은 구독 구매 시 명시된 이용약관 속 해지 정책에 따라 계산됩니다.
                </div>
            </div>

            <div className="ButtonBox">
                <MgButton text="유지하기" onClick={onCloseView} addStyles={MaintainStyle} />

                <div className="TerminateButtonBox">
                    <button
                        className="Now"
                        onClick={() => {
                            if (subsRefundAmount?.penaltyType === 0 || subsRefundAmount?.penaltyPrice === 0) {
                                return setIsOpenImmediateTerminateNoneDeposit && setIsOpenImmediateTerminateNoneDeposit();
                            }
                            return onChangeStep(2);
                        }}
                    >
                        {subsRefundAmount?.penaltyType === 5 ? "해지하기" : "즉시 해지"}
                    </button>

                    {subsRefundAmount?.penaltyType !== 5 && !userSubsInfo?.name.includes("체험") && (
                        <button
                            className="Reservation"
                            onClick={() => {
                                setIsOpenReservationModal && setIsOpenReservationModal();
                            }}
                        >
                            해지 예약
                        </button>
                    )}
                </div>
            </div>
        </ContentBoxSecondStyle>
    );
};
export default TerminateFirstStep;

const MaintainStyle = css`
    background: #2275ee;
    color: #ffffff;
`;

const ContentBoxStyle = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    padding: 0 14px 24px;
    text-align: center;
    gap: 14px;
    .title {
        font-weight: 700;
        font-size: 16px;
        line-height: 26px;
    }
    .content {
        font-size: 16px;
        font-weight: 400;
        line-height: 26px;
    }
    .footer {
        text-align: left;
        color: #8d8d8d;
        font-size: 12px;
        font-weight: 400;
        line-height: 20px;
        padding: 8px 14px;
        border-radius: 8px;
        background-color: #f7f8fa;
    }
`;

const ContentBoxSecondStyle = styled.div`
    height: calc(100vh - 56px - 260px);
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: space-between;
    padding: 0px 14px 18px 14px;
    text-align: center;

    .ExplanationBox {
        display: flex;
        flex-direction: column;
        gap: 24px;

        .ExplanationTitle {
            color: #0c002c;
            font-size: 16px;
            font-style: normal;
            font-weight: 400;
            line-height: 26px;
        }

        .ExplanationSubTitle {
            color: #0c002c;
            font-size: 16px;
            font-style: normal;
            font-weight: 700;
            line-height: 26px;
        }

        .ExplanationText {
            display: flex;
            align-items: center;
            justify-content: start;
            padding: 8px 14px;

            border-radius: 8px;
            background: #f7f8fa;

            text-align: left;
            color: #8d8d8d;
            font-size: 12px;
            font-style: normal;
            font-weight: 400;
            line-height: 20px;
        }
    }

    .ButtonBox {
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        gap: 12px;

        .TerminateButtonBox {
            width: 100%;
            display: flex;
            flex-direction: row;
            align-items: center;
            justify-content: space-between;
            gap: 12px;

            button {
                width: 100%;
                padding: 14px;
                cursor: pointer;

                border-radius: 14px;

                color: #0c002c;
                text-align: center;
                font-size: 18px;
                font-style: normal;
                font-weight: 400;
                line-height: 28px;
            }
            .Reservation {
                background-color: #dff0ff;
            }
            .Now {
                background-color: #ebebeb;
            }
        }
    }
`;

const BtnBoxStyle = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    .clickSpan {
        text-decoration-line: underline;
        text-underline-position: under;
        color: #8d8d8d;
        font-size: 14px;
        font-weight: 400;
        line-height: 24px;
        cursor: pointer;
        display: inline-block;
        padding: 14px 0;
    }
`;

const PenaltyTextStyle = styled.span`
    color: #ffffff;
    text-align: center;
    font-size: 16px;
    font-weight: 400;
    line-height: 162.5%;
    background-color: #ff0000;
    margin-right: 0.125rem;
    padding: 4px 0.15rem;
`;
